import { http } from '@/api/http';

export interface EndgameListItem {
  slug: string;
  name: string;
  fen: string;
  side_to_move: 'white' | 'black';
  target_outcome: 'win' | 'draw' | 'defend';
  theme: string;
  sub_theme: string | null;
  source_kind: string;
  source_ref: string;
  eval_at_start: string | null;
  piece_count: number;
}

export interface EndgameDetail extends EndgameListItem {
  key_moves: string[];
  trainer_modes: Array<'play_against_engine' | 'find_plan' | 'defend_inferior'>;
  eval_engine: string | null;
  explanation: string;
}

export interface EndgameAttemptPayload {
  module: 'endgame';
  slug: string;
  kind: 'endgame_position';
  fen: string;
  side_to_move: 'white' | 'black';
  mode: 'endgame_play_against_engine' | 'endgame_find_plan' | 'endgame_defend';
  result: 'success' | 'partial' | 'fail';
  played_move?: string;
  expected_move?: string;
  time_spent_ms: number;
  source_ref?: string;
}

export interface AttemptResponse {
  attempt_id: number;
  item_id: number;
  card_created: boolean;
  card_id: number | null;
}

export const endgameApi = {
  list: (params: { theme?: string; outcome?: 'win' | 'draw' | 'defend'; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.theme) qs.set('theme', params.theme);
    if (params.outcome) qs.set('outcome', params.outcome);
    if (params.limit) qs.set('limit', String(params.limit));
    return http.get<{ count: number; endgames: EndgameListItem[] }>(
      `/api/v1/content/endgames?${qs.toString()}`,
    );
  },
  detail: (slug: string) =>
    http.get<EndgameDetail>(`/api/v1/content/endgames/${encodeURIComponent(slug)}`),
  postAttempt: (payload: EndgameAttemptPayload) =>
    http.post<AttemptResponse>('/api/v1/training/attempts', payload),
};
